import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";

//Simple hook to get the dispatch function from the store
export const useAppDispatch = () => useDispatch<AppDispatch>();
//Simple hook to get the state from the store
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
